import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'empty-speech',
  templateUrl: './empty-speech.component.html',
  styleUrls: ['./empty-speech.component.css'],
})
export class EmptySpeechComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
